import { CONN_TYPE, ID_MSG, VERSION, AD_TYPES } from '../constants/TrackingConstants';

export default class ConsumerParams {
  constructor(rqTs, size, msg, hshj, ctmId, ts) {
    this.ev_st = 'client_monitoring';
    this.ev_ver = VERSION;
    this.ctm_id = ctmId;
    this.ts = ts;
    this.rq_ts = rqTs;
    this.conntype = CONN_TYPE;
    this.co_id = ID_MSG;
    this.ad_tp = this.getTypeBysize(size);
    this.msg = msg;
    this.count = 1;
    this.json_hash = hshj;
  }

  // eslint-disable-next-line class-methods-use-this
  getTypeBysize(size) {
    const sizeStr = size.join('x');
    const type = Object.entries(AD_TYPES).filter((types) => types[1].includes(sizeStr));
    return type[0][0];
  }

  setTimestamp(ts) {
    this.ts = ts;
    return this;
  }

  setAdType(adTp) {
    this.ad_tp = adTp;
    return this;
  }

  setMsg(msg) {
    this.msg = msg;
    return this;
  }

  setCount(count) {
    this.count = count;
    return this;
  }

  setJsonHash(hshj) {
    this.hshj = hshj;
    return this;
  }

  build() {
    return {
      ev_st: this.ev_st,
      ev_ver: this.ev_ver,
      ctm_id: this.ctm_id,
      ts: this.ts,
      rq_ts: this.rq_ts,
      conntype: this.conntype,
      co_id: this.co_id,
      ad_tp: this.ad_tp,
      msg: this.msg,
      count: this.count,
      json_hash: this.json_hash,
    };
  }
}
